import { render, staticRenderFns } from "./ChooseCommunity.vue?vue&type=template&id=49ede637&scoped=true&"
import script from "./ChooseCommunity.vue?vue&type=script&lang=js&"
export * from "./ChooseCommunity.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCommunity.vue?vue&type=style&index=0&id=49ede637&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ede637",
  null
  
)

export default component.exports